import $ from "jquery";

import "../scss/child-template.scss";
import "./scripts/careers/faq.js";

// Animation for person image on cta section
const imgPerson = document.querySelector('.img-person');

const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
        }
    });
}, {
    threshold: 0.1
});

observer.observe(imgPerson);
